import { render, staticRenderFns } from "./AddNewItemPopup.vue?vue&type=template&id=5f7a449d&scoped=true"
import script from "./AddNewItemPopup.vue?vue&type=script&lang=js"
export * from "./AddNewItemPopup.vue?vue&type=script&lang=js"
import style0 from "./AddNewItemPopup.vue?vue&type=style&index=0&id=5f7a449d&prod&lang=scss&scoped=true"
import style1 from "./AddNewItemPopup.vue?vue&type=style&index=1&id=5f7a449d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a449d",
  null
  
)

export default component.exports